export default "__VITE_ASSET__B6IF6OcP__"